export default __webpack_public_path__ + "components/homepage-hero/static/hero-bg-5bfc64fd939a2ed1390ffb8f52721390.jpg";